/*
 *   File : footer.js
 *   Author : https://evoqins.com
 *   Description : footer component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React from "react";

export default function Footer() {
  return (
    <div
      className="e-glass-bg position-relative d-flex justify-content-center py-36 align-items-center"
      style={{ zIndex: 1 }}
    >
      <h3 className="fs-16 fw-400 text-eerie-black mb-0">
        © {new Date().getFullYear()} FundsApp. All rights reserved.
      </h3>
    </div>
  );
}
